// GameOver.js
// Displays the winner and a button to return to the start screen
import React from "react";
import './GameOver.css';

export default function GameOver({ winner, onRestart }) {
    return (
        <div className="gameover-modal">
            <div className="gameover-content">
                <h1 className="gameover-title">Game Over!</h1>
                <p className="gameover-winner">Winner: <span>{winner}</span></p>
                <button className="gameover-btn" onClick={onRestart}>Back To Menu</button>
            </div>
        </div>
    );
}
